import React from 'react'
import { Flex } from '@components'
import { Form, Input, Row, Col, Button, Modal, Upload, Icon, message, Spin, InputNumber, Select, Alert, Tooltip } from 'antd'
import SiderMenu from '@pages/Assembly/siderMenu'
import Breadcrumb from '@pages/Assembly/Breadcrumb'
import TitleTop from '@pages/Assembly/titleTop'
import { createUuid, getLoginUser } from '@utils/NHCore'
import NHFetch from '@utils/NHFetch'
const Dragger = Upload.Dragger
import CommonTip from '@pages/SelfHelp/common'
import NextButton from '@pages/SelfHelp/common/nextIndex'
import { mkbz } from '@pages/Assembly/siderMenu/menuObj'
import Hint from '@pages/SelfHelp/common/hint'
import NHFormItem from '@components/common/NHFormItem'
import NHSelect from '@components/common/NHSelect'
import styles from './index.css'

const { TextArea } = Input
const FormItem = Form.Item
const formItemLayout = {
  labelCol: { span: 9 },
  wrapperCol: { span: 15 }
}
const Option = Select.Option

@Form.create()
export default class FinancialMatters extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mkbz: 'GD042',
      hjmc: '',
      uploading: false,
      loading: false,
      previewVisible: false,
      fileList: [],
      data: {}, //绿色通道申请信息
      nextUrl: '',
      search: '',
      operable: true, //是否显示环节
      nonOperationalData: {}, //不可操作的数据
      judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'], //可以导入的图片格式
      judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'], //可以导入的非图片格式
      yjfyInfo: {},
      showData: {}, //显示的表单数据
      // 是否成年
      isAdult: false,
      cwsxnr: '', //财务事项内容
      isHjLinked: false,
    }
  }

  componentDidMount() {
    let userInfo = getLoginUser()

    let xsid = userInfo ? userInfo.userId : null
    // console.log(xsid, "-------xsid------")
    this.getShowData(xsid)
    this.getCwsxPz()

    this.queryQztjAndYlhj(operable => {
      if (operable) {
        // this.loadLstdInfo()
        this.updateZzbdBlzt()
      }
    })
  }

  //迎新现场已办理时迎新网站自动办理
  updateZzbdBlzt = () => {
    let zzbdhjid = this.getQueryString('pkid')
    NHFetch('/zzbd/updateZzbdBlzt', 'GET', { zzbdhjid: zzbdhjid, hjdm: 'GD042' }).then(res => {
      if (res.data) {
        this.reloadMenu()
      }
    })
  }

  //查询前置条件和依赖环节
  queryQztjAndYlhj = callback => {
    let xsid = getLoginUser() ? getLoginUser().userId : ''
    if (!xsid) {
      this.setState({
        nonOperationalData: { nologin: true },
        operable: false
      })
      return
    }
    let zzbdhjid = this.getQueryString('pkid')
    NHFetch('/zzbd/queryQztjAndYlhj', 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(res => {
      if (res && res.data) {
        let kfsj = res.data['kfsj']
        let ylhj = res.data['ylhj']
        let qzhj = res.data['qzhj']
        let nohj = res.data['nohj']
        this.setState({ nonOperationalData: res.data })
        if (kfsj && kfsj['YXSJ'] != '1') {
          this.setState({ operable: false })
        }

        if (ylhj && ylhj.length > 0) {
          this.setState({ operable: false })
        }

        if (qzhj && qzhj.length > 0) {
          this.setState({ operable: false })
        }

        if (nohj) {
          this.setState({ operable: false })
        }

        if (callback) {
          callback(this.state.operable)
        }
      }
    })
  }

  getQueryString = name => {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  }

  setMenuList = menuList => {
    let nextCount = 0
    let bz = this.state.mkbz
    menuList.map((elem, index) => {
      if (elem.HJDM == bz) {
        let hjmc = elem.HJMC
        this.setState({ hjmc: hjmc })
        nextCount = index + 1
        return
      }
    })
    let menu = menuList[nextCount]
    if (menu) {
      let hjdm = menu.HJDM
      if (hjdm.indexOf('GD') == 0) {
        let gdUrl = mkbz[hjdm]
        this.setState({
          nextUrl: gdUrl,
          search: 'pkid=' + menu.PKID
        })
      } else if (hjdm.indexOf('ZDY') == 0) {
        let zdyUrl = '/customLink'
        this.setState({
          nextUrl: zdyUrl,
          search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
        })
      }
    } else {
      this.setState({
        nextUrl: '',
        search: ''
      })
    }
  }
  // 获取办卡确认书配置
  getCwsxPz = () => {
    NHFetch(`api/zhxg-yxwz/zzbd/getCwsx`, 'GET').then(res => {
      if (res && res.code === 200) {
        let nr = res.data?.nr ?? '';
        this.setState({ cwsxnr: nr })
      }
    })
  }

  // 获取展示数据及判断 是否满18周岁  
  getShowData = (xsid) => {
    let showData = {}
    let url = `api/zhxg-yxwz/zzbd/getStudentChargingSituation?xsid=${xsid}`
    NHFetch(url, 'GET').then(res => {
      // console.log(res.data, "---------res.data----")
      if (res.data) {
        showData = res.data || {}
        if (showData.sfcn === '已满18岁') {
          this.setState({ isAdult: true })
        } else {
          this.setState({ isAdult: false })
        }
        this.setState({ showData: showData })
      }
    })
  }


  updateStatus = () => {
    let xsid = getLoginUser() ? getLoginUser().userId : '';
    let zzbdhjid = this.getQueryString('pkid');
    let postData = {
      'zzbdhjid': zzbdhjid,
      'xsid': xsid
    }
    NHFetch('/zzbd/commonSaveLinkTransactionStatus', 'POST', postData)
      .then(res => {
        if (res) {
          message.success("已确认办理");
          this.reloadMenu();
          this.setState({ isHjLinked: true });
        }
      });
  }

  //重新加载菜单
  reloadMenu = () => {
    this.refs.siderMenu.reloadMenuList()
  }

  render() {
    const { form } = this.props
    const { getFieldDecorator, getFieldValue } = this.props.form
    const { previewImage, previewVisible, data, yjfyInfo, showData, isAdult } = this.state
    const props = {
      name: 'file',
      action: 'zuul/docrepo/upload',
      data: { uuid: createUuid(), type: '1' },

      onRemove: file => {
        this.setState(
          ({ fileList }) => {
            const index = fileList.indexOf(file)
            const newFileList = fileList.slice()
            newFileList.splice(index, 1)
            this.props.form.setFieldsValue({ fj: { fileList: newFileList } })
            return {
              fileList: newFileList
            }
          },
          () => {
            if (file.response && file.response.data && file.response.data.ssbh) {
              this.remove(file.response.data.ssbh)
            }
          }
        )
      },
      beforeUpload: file => {
        if (!this.beforeUpload(file)) {
          return false
        }
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file]
        }))
        return true
      },
      onChange: file => {
        this.handleChange(file)
      },
      onPreview: this.handlePreview,
      fileList: this.state.fileList
    }

    let edit = false
    if (JSON.stringify(data) == '{}' || !data) {
      edit = true
    }

    let btn01Img = require('@images/channelDllgdx/btn01.png')
    let btn02Img = require('@images/channelDllgdx/btn02.png')

    let message1 = <div style={{color:'rgba(0, 0, 0, 0.65)',fontFamily: '仿宋_GB2312'}}>
      <p className={styles.tip_title} style={{marginLeft:'5px'}}>
        一、学生缴费事项
      </p>
      <p className={styles.textCss}>
        &nbsp;&nbsp;&nbsp;&nbsp;新生应在入学一个月内缴纳学费、住宿费及本科新生代收款（体检费、军训服代购费、教材预收款），具体要求详见大连理工大学新生缴费说明。
      </p>
      <p className={styles.payTips}>大连校区2025级新生：<a href={`${window.location.origin}${window.location.pathname}#/notice/detail?pkid=cb8c2cf8-bbb1-496a-bf85-7dd90b954bea`}>缴费说明</a></p>
      <p className={styles.payTips}>盘锦校区2025级新生：<a href={`${window.location.origin}${window.location.pathname}#/notice/detail?pkid=34299bc8-77be-45b1-847e-16f36731a461`}>缴费说明</a></p>
      <p className={styles.tip_title}>
        二、学生银行卡相关事项
      </p>
      <p className={styles.textCss}>
        &nbsp;&nbsp;&nbsp;&nbsp;由于学校开户银行为中国建设银行，学生在校期间发放奖助学金等各类补贴均通过建行储蓄卡发放，新生必须办理并激活建行储蓄卡。学生办理的建行银行卡必须进行银行卡信息维护，方能正常发放使用。
      </p>
      <p className={styles.textCss}>
        &nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.tip_strong}>1、未满18周岁的学生，</span>请在户籍所在地办理建行卡。
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;由于未满18周岁的学生，因受监护权限制，必须监护人陪同到中国建设银行营业网点办理，需持监护人及新生身份证原件、能证明直系亲属关系的户口本或出生证明原件办理。
      </p>
      <p className={styles.textCss}>
        &nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.tip_strong}>2、学生银行卡信息维护流程：</span>请手机登录“大连理工大学财务平台”微信公众号，进入“财务平台”，通过校园统一身份认证登录系统。点击“菜单”——“我的”——“银行卡维护”。
      </p>

      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', width: '100%', gap: '12px', padding: '8px 0' }}>
        {/* <Button size='middle'>点击绑定个人银行卡</Button> */}
        <Button size='middle' onClick={() => { window.open('http://pay.dlut.edu.cn'), '_blank' }}>我要缴费</Button>
      </div>
    </div>
    let message2 = <div style={{color:'rgba(0, 0, 0, 0.65)',fontFamily: '仿宋_GB2312'}}>
      <p className={styles.tip_title} style={{marginLeft:'5px'}}>
        一、学生缴费事项
      </p>
      <p className={styles.textCss}>
        &nbsp;&nbsp;&nbsp;&nbsp;新生应在入学一个月内缴纳学费、住宿费及本科新生代收款（体检费、军训服代购费、教材预收款），具体要求详见大连理工大学新生缴费说明。
      </p>
      <p className={styles.payTips}>大连校区2025级新生：<a href={`${window.location.origin}${window.location.pathname}#/notice/detail?pkid=cb8c2cf8-bbb1-496a-bf85-7dd90b954bea`}>缴费说明</a></p>
      <p className={styles.payTips}>盘锦校区2025级新生：<a href={`${window.location.origin}${window.location.pathname}#/notice/detail?pkid=34299bc8-77be-45b1-847e-16f36731a461`}>缴费说明</a></p>
      <p className={styles.tip_title}>
        二、学生银行卡相关事项
      </p>
      <p className={styles.textCss}>
        &nbsp;&nbsp;&nbsp;&nbsp;由于学校开户银行为中国建设银行，学生在校期间发放奖助学金等各类补贴均通过建行储蓄卡发放，新生必须办理并激活建行储蓄卡。学生办理的建行银行卡必须进行银行卡信息维护，方能正常发放使用。
      </p>
      <p className={styles.textCss}>
        &nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.tip_strong}>1、已满18周岁的学生，</span>可在户籍所在地办理，也可待报到后根据学校通知统一办理或到周边建行网点自行办理。
      </p>
      <p className={styles.textCss}>
        &nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.tip_strong}>2、学生银行卡信息维护流程：</span>请手机登录“大连理工大学财务平台”微信公众号，进入“财务平台”，通过校园统一身份认证登录系统。点击“菜单”——“我的”——“银行卡维护”。
      </p>

      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', width: '100%', gap: '12px', padding: '8px 0' }}>
        {/* <Button size='middle'>点击绑定个人银行卡</Button> */}
        <Button size='middle' onClick={() => { window.open('http://pay.dlut.edu.cn'), '_blank' }}>我要缴费</Button>
      </div>
    </div>

    return (
      <div style={{ position: 'relative' }}>
        {this.state.operable ? (
          <div>
            <Flex className="w1180 mt-20" align="start">
              <SiderMenu ref={'siderMenu'} setMenuList={this.setMenuList} title="自助报到" mkbz={this.state.mkbz} menuType="自助报到" />
              <Flex.Item className="page_con_r" styleName="">
                <Breadcrumb noLine list={[{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]} />
                <div className="box">
                  <Hint />
                  <TitleTop title="财务事项" extra={false} />
                  <div className={styles.content}>
                    <div className={styles.tips}>
                    {this.state.cwsxnr ? (
                      <Alert message={<div dangerouslySetInnerHTML={{ __html: this.state.cwsxnr }} />} type="info" showIcon />
                    ) : (
                      <Alert message={isAdult ? message2 : message1} type="info" showIcon />
                    )}
                    </div>
                    {/* 
                    <div className={styles.showItem}>
                      <label>学费：</label>
                      <span>{showData.xh ? (showData.xf ? showData.xf : '0.00元') : '待确认'}</span>
                    </div>
                    <div className={styles.showItem}>
                      <label>住宿费：</label>
                      <span>{showData.xh ? (showData.zsf ? showData.zsf : '0.00元') : '待确认'}</span>
                    </div>
                    <div className={styles.showDsk}>
                      <label>代收款（体检费、军训服代购费、教材预收款）：</label>
                      <div>
                          {showData.dsk ? showData.dsk : '暂无'}
                      </div>
                    </div> */}
                  </div>

                  <div className="text-center mt-50">
                    {!this.state.isHjLinked &&
                      <Button
                        onClick={() => this.updateStatus()}
                        type="primary"
                        htmlType="submit"
                      >
                        确认知悉
                      </Button>}
                    <NextButton nextUrl={this.state.nextUrl} search={this.state.search} />
                  </div>
                </div>
              </Flex.Item>
            </Flex>
            <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
              <img alt="example" style={{ width: '100%' }} src={previewImage} />
            </Modal>
            <Spin style={{ position: 'absolute', top: '300px', left: '60%' }} spinning={this.state.loading} />{' '}
          </div>
        ) : (
          <CommonTip hjmc={'财务事项'} key={'GD042'} mkbz="GD042" nonOperationalData={this.state.nonOperationalData} />
        )}
      </div>
    )
  }
}
